var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolicydelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 30.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9138",
    opacity: 0.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Send message, Send, Share"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5710",
    d: "M6.25 6.25h18v18h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5711",
    d: "M17.233 21.181l4.092-11.04a.75.75 0 00-.964-.964L9.318 13.272a.75.75 0 00.073 1.43l5.13 1.288 1.28 5.112a.751.751 0 001.432.079z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5712",
    d: "M21.152 9.347l-6.63 6.645",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7329",
    d: "M15.25 29.75h0a14.5 14.5 0 01-14.5-14.5h0A14.5 14.5 0 0115.25.75h0a14.5 14.5 0 0114.5 14.5h0a14.5 14.5 0 01-14.5 14.5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

export default SvgPolicydelivery;


//////////////////
// WEBPACK FOOTER
// ./src/icons/policy delivery.svg
// module id = 791
// module chunks = 101